import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type { API } from '@trinity/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { FilesMap } from '@trinity/chat-components/containers/WorkspaceFileUpload/interfaces.js';

export const usePreFileUploadMutation = (options?: Options) => {

  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationFn: data => {
      const files = Object.keys(data.files).map(identifier => {
        const file = data.files[identifier];
        return {
          identifier,
          name: file.name,
          size: file.size,
          type: file.type,
        };
      });

      return apiClient.workspacesFileUpload.fileUploadPreCheck({
        ...data,
        files,
      });
    }, ...options,
  });

  return mutation;
};

type Data = API.WorkspaceFileUpload.FileUploads.FileUploadPreCheck.Response;
type Vars = Omit<API.WorkspaceFileUpload.FileUploads.FileUploadPreCheck.Request, 'files'> & {
  files: FilesMap;
  isTranscriptImport: boolean;
  respondentCountry: string;
};
type Options = UseMutationOptions<Data, AxiosResponse, Vars>;